"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserIdType = void 0;
var driftTypes_1 = require("@driftt/app-config/dist/utils/driftTypes");
Object.defineProperty(exports, "UserIdType", {
  enumerable: true,
  get: function get() {
    return driftTypes_1.UserTypeIF;
  }
});